import edgeCommon from './common';
import slider from './site-assets/slider';

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

let custom = function() {
    
    let addValidations = function () {
        $("#registration").validate({
            ignore: "",
            errorClass: "text-danger",
            rules: {
                first_name: { required: true, alphanumeric: true },
                last_name: { required: true, alphanumeric: true },
                email: {
                    required: true,
                    email: true,
                    remote: {
                        url: "/validate-email",
                        type: "POST",
                        data: {
                            /*email was the action and it will be sent as request key name*/
                            email: function () {
                                return $("#email").val(); //your email field
                            },
                        },
                    },
                },
                site: { required: true },
                company: { required: true, alphanumeric: true },
                title: { required: true, alphanumeric: true },
                country_code: { required: true },
                phone: { required: true, phoneRule: true },
                phone_extension: { number:true, minlength: 3, maxlength: 5 },
                phone_type: { required: true },
                company_size: { required: true },
                company_budget: { required: true },
                hear_about_us: { required: true },
                is_interested_in_helping_us: { required: true },
                term_condition: { required: true },
            },
            messages: {
                country_code: {
                    required: "Required",
                },
                email: {
                    remote: "Email address already exist",
                },
                phone_extension: {
                    minlength: "Please enter more than or equal to 3 numbers",
                    maxlength: "Please enter less than or equal to 5 numbers",
                }
            },
            errorPlacement: function (error, element) {
                if (element.attr("type") == "radio") {
                    error.insertAfter(element.parents(".group-radio"));
                } else if (element.attr("type") == "checkbox") {
                    error.insertAfter(element.parents(".group-checkbox"));
                } else {
                    error.insertAfter(element);
                }
            },
        });

        $("#add-strong-box").validate({
            ignore: "",
            errorClass: "text-danger",
            rules: {
                name: { required: true, maxlength: 15, alphanumeric: true },
                memory_size: { required: true, min: 2, max: ram_setting_size },
                cpu: { required: true, min: 1, max: cpu_setting_size },
                storage_size: "required",
                additional_drive_1: "required",
                additional_drive_2: "required",
                additional_drive_3: "required",
                os_version: { required: true },
                group_id: "required",
                guest_os: "required",
            },
            // messages: {
            //     brand: "Please enter brand",
            //     model: "Please enter model",
            //     phone_id: "Please enter phone id",
            //     ean_id: {
            //         required: "Please enter ean id",
            //         remote: "This ean id is already in use"
            //     }
            // },
            // submitHandler: function(form) {
            //     console.log('form');
            //     console.log(form);
            // },
            // errorPlacement: function(error, element) {
            //     if (element.hasClass('dynamic-required')) {
            //         version_id = element.attr("data-version-id");
            //         version = $('#version-tab-'+version_id).text()
            //         $('#version-tab-'+version_id).addClass('text-danger');
            //         fireTostr('error', version+' version data is required');
            //         element.after(error);
            //     }
            //     else {
            //         element.after(error); // default error placement
            //     }
            // }
        });

        $("#admin-profile").validate({
            ignore: "",
            errorClass: "text-danger",
            rules: {
                name: { required: true, alphanumeric: true },
                password: { minlength: 6 },
                password_confirmation: { minlength: 6, equalTo: "#password" },
            },
        });

        $("#profile").validate({
            ignore: "",
            errorClass: "text-danger",
            rules: {
                first_name: { required: true, alphanumeric: true },
                last_name: { required: true, alphanumeric: true },
                company: { required: true, alphanumeric: true },
                phone: { required: true, phoneRule: true },
                password: { minlength: 6 },
                password_confirmation: { minlength: 6, equalTo: "#password" },
            },
        });
        
        $("#profile-billing").validate({
            ignore: "",
            errorClass: "text-danger",
            rules: {
                billing_address: { required: true, alphanumeric: true },
                address_city: { required: true, alphanumeric: true },
                address_state: { required: true, alphanumeric: true },
                billing_zip: {required: true, minlength: 5, maxlength:10, zipCode: true},
                billing_country: { required: true, alphanumeric: true },
            },
        });
    };

    let updateBilling = function () {
        $("#update-billing").on("click", function () {
            if ($("#profile-billing").valid()) {
                $(".loading").removeClass("d-none");
                $.ajax({
                    url: $("#profile-billing").attr("data-url"),
                    type: "POST",
                    dataType: "JSON",
                    data: $("#profile-billing").serialize(),
                    success: function (response) {
                        $(".loading").addClass("d-none");
                        if (response.status == "success") {
                            edgeCommon.swalSuccess(response.message).then(() => {
                                window.location.reload();
                            });
                        }
                    },
                });
            }
        });
    };

    let updateProfile = function () {
        $("#update-profile").on("click", function () {
            if ($("#profile").valid()) {
                $(".loading").removeClass("d-none");
                $.ajax({
                    url: $("#profile").attr("data-url"),
                    type: "POST",
                    dataType: "JSON",
                    data: $("#profile").serialize(),
                    success: function (response) {
                        $(".loading").addClass("d-none");
                        if (response.status == "success") {
                            edgeCommon.swalSuccess(response.message).then(() => {
                                window.location.reload();
                            });
                        }
                    },
                });
            }
        });

        $("#update-admin-profile").on("click", function () {
            if ($("#admin-profile").valid()) {
                $(".loading").removeClass("d-none");
                $.ajax({
                    url: $("#profile").attr("data-url"),
                    type: "POST",
                    dataType: "JSON",
                    data: $("#admin-profile").serialize(),
                    success: function (response) {
                        $(".loading").addClass("d-none");
                        if (response.status == "success") {
                            edgeCommon.swalSuccess(response.message).then(() => {
                                window.location.reload();
                            });
                        }
                    },
                });
            }
        });
        
    };

    let updateStrongBox = function() {
        let strongBox = [];
        let secondStrongBox = [];
        let memorySize = 0;
        let cpuSize = 0;
        let storageSize = 0;
        let print = false;
        let isSubmit = false;
        let isOptimize = false;
        $('.submit-strong-box').on('click', function() {
            if($("#add-strong-box").valid()) {

                if($(this).data('print') != undefined){
                    print = true;
                }
                if($(this).attr('data-is-submit') != undefined){
                    isSubmit = $(this).attr('data-is-submit');
                }
                
                let formData = $('#add-strong-box').serializeArray();
                let formObject = {};
                $.each(formData, function(i, v) {
                    formObject[v.name] = v.value;
                });
                memorySize += parseInt(formObject.memory_size);
                cpuSize += parseInt(formObject.cpu);
                storageSize += parseInt(formObject.storage_size);
                
                if((memorySize <= ram_setting_size && cpuSize <= cpu_setting_size) || isSubmit ){
                    $('.memory').text(ram_setting_size - memorySize);
                    $('.cpu').text(cpu_setting_size - cpuSize);
                    
                    strongBox.push(formObject);                    
                    
                    let group_html = '';
                    $('#added-vm').empty();
                    let vmId = $('.total-vms').data('vms');
                    let totalStacks = $('.total-stacks').data('stacks');
                    let totalStorageCost = $('.storage-cost').data('storage-cost');
                    let totalMonthlyCost = 0;
                    let addStorage = 0;
                    let addStorageCost = 0;
                    
                    $.each(strongBox, function(key, value) {
                        let html = '';
                        let additional1Cost = '';
                        let additional2Cost = '';
                        let additional3Cost = '';
                        if(value.additional_drive_1 >0){
                           additional1Cost =`<small>($${Number(value.additional_drive_1 * per_gb_rate).toFixed(2)} /month)</small>`;
                        }
                        if(value.additional_drive_2 >0){
                           additional2Cost =`<small>($${Number(value.additional_drive_2 * per_gb_rate).toFixed(2)}/month)</small>`;
                        }
                        if(value.additional_drive_3 >0){
                            additional3Cost =`<small>($${Number(value.additional_drive_3 * per_gb_rate).toFixed(2)}/month)</small>`;
                        }
                        
                        html += `<div class="mb-3">
                                    <span><strong>VM#${++key}:</strong> ${value.name}</span><br>
                                    <span>Version: ${value.os_version}</span><br>
                                    <span>Memory: ${value.memory_size}GB</span><br>
                                    <span>CPUs: ${value.cpu}</span><br>
                                    <span>Storage: ${value.storage_size}GB &nbsp;<small>($${Number(value.storage_size *per_gb_rate).toFixed(2)} /month)</small></span><br>
                                    <span>Additional Storage 1: ${value.additional_drive_1??0}GB&nbsp;${additional1Cost}</span><br>
                                    <span>Additional Storage 2: ${value.additional_drive_2??0}GB&nbsp;${additional2Cost}</span><br>
                                    <span>Additional Storage 3: ${value.additional_drive_3??0}GB&nbsp;${additional3Cost}</span><br>
                                </div>`;
                        
                        if($('#group_'+value.group_id).length == 0){
                            group_html += `<div class="py-2 vm-contents mb-3 bg-light border-bottom" id="group_`+value.group_id+`">
                            <span><h4>Group:`+$('#group_id option[value='+value.group_id+']').text()+`</h4></span>`+html+`</div>`;

                            $('#added-vm').append(group_html);
                            group_html = '';
                        }else{
                            $('#added-vm #group_'+value.group_id).append(html);
                        }                        

                        let storageSizeValue = value.storage_size ? Number(value.storage_size) : 0;
                        let additional1 = value.additional_drive_1 ? Number(value.additional_drive_1) : 0;
                        let additional2 = value.additional_drive_2 ? Number(value.additional_drive_2) : 0;
                        let additional3 = value.additional_drive_3 ? Number(value.additional_drive_3) : 0;
                        addStorage = Number(addStorage + storageSizeValue + additional1 + additional2 + additional3);
                        ++vmId;
                    });
                    
                    totalStacks = Math.ceil((cpuSize + totalCPU) / cpu_setting_size) > Math.ceil((totalMemory + memorySize) / ram_setting_size) ? Math.ceil((cpuSize + totalCPU) / cpu_setting_size) : Math.ceil((totalMemory + memorySize) / ram_setting_size);

                    addStorageCost = parseFloat(totalStorageCost + (addStorage * per_gb_rate)).toFixed(2);
                    totalMonthlyCost = parseFloat(totalMonthlyCost + (per_stack * totalStacks) + Number(addStorageCost)).toFixed(2);
                    $('.total-vms').text(vmId);
                    $('.total-stacks').text(totalStacks);
                    $('.storage-cost').text(addStorageCost);
                    $('.monthly-cost').text(numberWithCommas(totalMonthlyCost));
                    
                    $('#add-strong-box')[0].reset();
                    
                    $("#cpu").attr({"max" : cpu_setting_size, "min" : 0, "step" : 2, "value" : 0});
                    $('#additional_drive_1').prop('disabled', true);
                    $('#additional_drive_2').prop('disabled', true);
                    $('#additional_drive_3').prop('disabled', true);
                    $('#additional_drive_1').val(0);
                    $('#additional_drive_2').val(0);
                    $('#additional_drive_3').val(0);
                    
                    $('#os_version').val('');
                    $('#group_id').val('');

                    $('#temp-vm').find('span').empty();
                    $('#temp-vm').removeClass('p-2');
                    
                    if((memorySize == ram_setting_size || cpuSize == cpu_setting_size ) || isSubmit){
                        addToStrongBox({ strongBox, print });
                    }
                } else {
                    memorySize -= formObject.memory_size;
                    cpuSize -= formObject.cpu;
                    storageSize -= formObject.storage_size;
                    let messageText = `
                        You are about to exceed the resources available. Doing so will create a new strongbox. The remaining resources from previous strongbox cant't be added to this new strongbox, since a strongbox can only have 32GB memory & 8 CPUs.
                        <br><br>
                        You will be able to add those resources later to existing VMs in the original strongbox. Or you can cancel the request and adjust now.
                    `;
                    Swal.fire({
                        title: 'Alert',
                        html: messageText,
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#d33',
                        cancelButtonColor: '#3085d6',
                        confirmButtonText: 'Create StrongBox',
                        cancelButtonText: 'Cancel Request'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            secondStrongBox.push(formObject);
                            addToStrongBox({ strongBox, secondStrongBox, print })
                        }
                    });
                }

                let isEmptyStrongBox = jQuery.isEmptyObject(strongBox); 
                if (isEmptyStrongBox) {
                    $('.continue-strong-box').addClass('d-none');
                    $('.strong-box-name').addClass('d-none');
                } else {
                    $('.continue-strong-box').removeClass('d-none');
                    $('.strong-box-name').removeClass('d-none');
                }
            }

        });

        $('.add-optimize-strong-box').on('click', function() {
            if($("#add-strong-box").valid()) {
                let isDraft = false;
                let isSubmit = false;
                let isOptimize = false;

                if($(this).attr('data-is-submit') != undefined){
                    isSubmit = $(this).attr('data-is-submit');
                }

                if($(this).attr('data-is-optimize') != undefined){
                    isOptimize = $(this).attr('data-is-optimize');
                }

                if($(this).attr('data-is-draft') != undefined){
                    isDraft = $(this).attr('data-is-draft');
                }
                
                let formData = $('#add-strong-box').serializeArray();
                let formObject = {};
                $.each(formData, function(i, v) {
                    formObject[v.name] = v.value;
                });
                memorySize += parseInt(formObject.memory_size);
                cpuSize += parseInt(formObject.cpu);
                storageSize += parseInt(formObject.storage_size);
                
                
                    $('.memory').text(ram_setting_size - memorySize);
                    $('.cpu').text(cpu_setting_size - cpuSize);
                    
                    strongBox.push(formObject);
                    
                    let group_html = '';
                    $('#added-vm').empty();
                    let vmId = $('.total-vms').data('vms');
                    let totalStacks = $('.total-stacks').data('stacks');
                    let totalStorageCost = $('.storage-cost').data('storage-cost');
                    let totalMonthlyCost = 0;
                    let addStorage = 0;
                    let addStorageCost = 0;
                    $.each(strongBox, function(key, value) {
                        let html = '';
                        let additional1Cost = '';
                        let additional2Cost = '';
                        let additional3Cost = '';
                        if(value.additional_drive_1 >0){
                           additional1Cost =`<small>($${Number(value.additional_drive_1 * per_gb_rate).toFixed(2)} /month)</small>`;
                        }
                        if(value.additional_drive_2 >0){
                           additional2Cost =`<small>($${Number(value.additional_drive_2 * per_gb_rate).toFixed(2)}/month)</small>`;
                        }
                        if(value.additional_drive_3 >0){
                           additional3Cost =`<small>($${Number(value.additional_drive_3 * per_gb_rate).toFixed(2)}/month)</small>`;
                        }

                        html += `<div class="p-2 vm-contents vm-div-`+key+`  bg-white border-bottom">
                                    <a href="javascript:;" class="btn btn-sm btn-danger remove-vm float-end" data-key="`+key+`" data-cpu="`+value.cpu+`" data-memory="`+value.memory_size+`">DELETE VM</a>
                                    <span><strong>VM#${++key}:</strong> ${value.name}</span><br>
                                    <span>Version: ${value.os_version}</span><br>
                                    <span>Memory: ${value.memory_size}GB</span><br>
                                    <span>CPUs: ${value.cpu}</span><br>
                                    <span>Storage: ${value.storage_size}GB &nbsp;<small>($${Number(value.storage_size *per_gb_rate).toFixed(2)} /month)</small></span><br>
                                    <span>Additional Storage 1: ${value.additional_drive_1??0}GB&nbsp;${additional1Cost}</span><br>
                                    <span>Additional Storage 2: ${value.additional_drive_2??0}GB&nbsp;${additional2Cost}</span><br>
                                    <span>Additional Storage 3: ${value.additional_drive_3??0}GB&nbsp;${additional3Cost}</span><br>
                                </div>`;
                        
                        if($('#group_'+value.group_id).length == 0){
                            group_html += `<div class="p-2 vm-contents mb-3 bg-light border-bottom" id="group_`+value.group_id+`">
                            <span><h4>Group: `+$('#group_id option[value='+value.group_id+']').text()+`</h4></span><hr>`+html+`</div>`;

                            $('#added-vm').append(group_html);
                            group_html = '';
                        }else{
                            $('#added-vm #group_'+value.group_id).append(html);
                        }
                        let storageSizeValue = value.storage_size ? Number(value.storage_size) : 0;
                        let additional1 = value.additional_drive_1 ? Number(value.additional_drive_1) : 0;
                        let additional2 = value.additional_drive_2 ? Number(value.additional_drive_2) : 0;
                        let additional3 = value.additional_drive_3 ? Number(value.additional_drive_3) : 0;
                        addStorage = Number(addStorage + storageSizeValue + additional1 + additional2 + additional3);
                        ++vmId;
                    });
                    
                    totalStacks = Math.ceil((cpuSize + totalCPU) / cpu_setting_size) > Math.ceil((totalMemory + memorySize) / ram_setting_size) ? Math.ceil((cpuSize + totalCPU) / cpu_setting_size) : Math.ceil((totalMemory + memorySize) / ram_setting_size);
                    
                    addStorageCost = totalStorageCost + (addStorage * per_gb_rate);
                    totalMonthlyCost = parseFloat(totalMonthlyCost + (per_stack * totalStacks) + Number(addStorageCost)).toFixed(2);
                    $('.total-vms').text(vmId);
                    $('.total-stacks').text(totalStacks);
                    $('.storage-cost').text(parseFloat(addStorageCost).toFixed(2));
                    $('.monthly-cost').text(totalMonthlyCost);
                    
                    $('#add-strong-box')[0].reset();
                    
                    $("#cpu").attr({"max" : cpu_setting_size, "min" : 0, "step" : 2, "value" : 0});
                    $('#additional_drive_1').prop('disabled', true);
                    $('#additional_drive_2').prop('disabled', true);
                    $('#additional_drive_3').prop('disabled', true);
                    $('#additional_drive_1').val(0);
                    $('#additional_drive_2').val(0);
                    $('#additional_drive_3').val(0);
                    $('#group_id').val('');

                    $('#temp-vm').find('span').empty();
                    $('#temp-vm').removeClass('p-2');

                    $('#guest_os1').trigger('click');

                    if(isDraft){
                        optimizeStrongBox({ strongBox });
                    }

                let isEmptyStrongBox = jQuery.isEmptyObject(strongBox); 
                if (isEmptyStrongBox) {
                    $('.continue-strong-box').addClass('d-none');
                    $('.strong-box-name').addClass('d-none');
                } else {
                    $('.continue-strong-box').removeClass('d-none');
                    $('.strong-box-name').removeClass('d-none');
                }
                $('.submit-optimize-strong-box').removeClass('d-none');
            }

            $('.remove-vm').click(function(){
                let key = $(this).attr('data-key');
                
                cpuSize -= $(this).attr('data-cpu');
                memorySize -= $(this).attr('data-memory');
                
                strongBox.splice(key, 1);

                let vmId = $('.total-vms').data('vms');
                let totalStacks = $('.total-stacks').data('stacks');
                let totalStorageCost = $('.storage-cost').data('storage-cost');
                let totalMonthlyCost = 0;
                let addStorage = 0;
                let addStorageCost = 0;
                $.each(strongBox, function(key, value) {
                    let storageSizeValue = value.storage_size ? Number(value.storage_size) : 0;
                    let additional1 = value.additional_drive_1 ? Number(value.additional_drive_1) : 0;
                    let additional2 = value.additional_drive_2 ? Number(value.additional_drive_2) : 0;
                    let additional3 = value.additional_drive_3 ? Number(value.additional_drive_3) : 0;
                    addStorage = Number(addStorage + storageSizeValue + additional1 + additional2 + additional3);
                    ++vmId;
                });
                
                totalStacks = Math.ceil((cpuSize + totalCPU) / cpu_setting_size) > Math.ceil((totalMemory + memorySize) / ram_setting_size) ? Math.ceil((cpuSize + totalCPU) / cpu_setting_size) : Math.ceil((totalMemory + memorySize) / ram_setting_size);
                
                addStorageCost = totalStorageCost + (addStorage * per_gb_rate);
                totalMonthlyCost = parseFloat(totalMonthlyCost + Number((per_stack * totalStacks)) + Number(addStorageCost)).toFixed(2);
                $('.total-vms').text(vmId);
                $('.total-stacks').text(totalStacks);
                $('.storage-cost').text(parseFloat(addStorageCost).toFixed(2));
                $('.monthly-cost').text(totalMonthlyCost);

                $(this).parent('div').remove();
                $('.remove-vm').each( function(key, value) {
                    $(this).attr('data-key', key);
                })
                if(strongBox.length == 0){
                    $('.submit-optimize-strong-box').addClass('d-none');
                }else{
                    $('.submit-optimize-strong-box').removeClass('d-none');
                }
            })

        });

        $(".optimize-selected").on("click", function () {
            let total = $(".accordion").find('input[name="strongBox[]"]:checked').length;
            if (total <= 0) {
                Swal.fire({
                    title: "Please select at-least one strongbox",
                    type: "warning",
                    confirmButtonColor: "#198754",
                    confirmButtonText: "CLOSE THIS MESSAGE",
                    width: "800px",
                });
            } else {
                let messageText = "You have selected " + total + " strongboxes to Optimize is this correct?";
                Swal.fire({
                    title: messageText,
                    type: "warning",
                    width: "900px",
                    showCancelButton: true,
                    confirmButtonColor: "#198754",
                    cancelButtonColor: "#dc3545",
                    confirmButtonText: "YES, OPTIMIZE THESE STRONGBOXES",
                    cancelButtonText: "NO, I DON'T NEED TO OPTIMIZE",
                }).then((result) => {
                    if (result.isConfirmed) {
                        let strongBoxes = new Array();
                        $.each(
                            $("input[name='strongBox[]']:checked"),
                            function () {
                                strongBoxes.push($(this).val());
                            }
                        );
                        optimizeSelectedStrongBox({ strongBoxes });
                    }
                });
            }
        });

        $(".submit-optimize-strong-box").on("click", function () {
            let isEmptyStrongBox = jQuery.isEmptyObject(strongBox);
            if (isEmptyStrongBox) {
                edgeCommon.swalWarning("Please add at-least one vm in strongbox");
            } else {
                optimizeStrongBox({ strongBox });
            }
        });

        $(".continue-strong-box").on("click", function () {
            let strongbox_name = $("#strongbox_name").val();
            let isEmptyStrongBox = jQuery.isEmptyObject(strongBox);
            $("#sb-error").text(" ");
            if (!strongbox_name) {
                $('<label id="sb-error" class="text-danger">This field is required.</label>').insertAfter("#strongbox_name");
            } else if (isEmptyStrongBox) {
                edgeCommon.swalWarning("Please add at-least one vm in strongbox");
            } else {
                addToStrongBox({ strongBox, strongbox_name });
            }
        });

        $("#additional_drive_1").prop("disabled", true);
        $("#additional_drive_2").prop("disabled", true);
        $("#additional_drive_3").prop("disabled", true);
        $("#additional_drive_1").val(0);
        $("#additional_drive_2").val(0);
        $("#additional_drive_3").val(0);

        $("#add_drive_2_output").prop("disabled", true);
        $("#add_drive_3_output").prop("disabled", true);

        $("#is_additional_drive_1").on("click", function () {
            if ($("#is_additional_drive_1").is(":checked")) {
                $("#additional_drive_div").removeClass("d-none");
                $("#additional_drive_1").prop("disabled", false);
                $('#additional_drive_1').parent().removeClass('disabled');
                $('#additional_drive_1').parent().find('div').removeClass('disabled');
            } else {
                $("#additional_drive_1").val(50);
                $("#add_drive_output").val(50);
                $(".temp-additional_drive_1").empty();
                $("#additional_drive_1").prop("disabled", true);
                $("#add_drive_output").prop("disabled", true);
                $('#additional_drive_1').parent().addClass('disabled');
                $('#additional_drive_1').parent().find('div').addClass('disabled');

                if (!$("#is_additional_drive_2").is(":checked") && !$("#is_additional_drive_3").is(":checked")) {
                    $("#additional_drive_div").addClass("d-none");
                }
            }
        });

        $("#is_additional_drive_2").on("click", function () {
            if ($("#is_additional_drive_2").is(":checked")) {
                $("#additional_drive_2").prop("disabled", false);
                $("#add_drive_2_output").prop("disabled", false);
                $('#additional_drive_2').parent().removeClass('disabled');
                $('#additional_drive_2').parent().find('div').removeClass('disabled');
            } else {
                $("#additional_drive_2").val(50);
                $("#add_drive_2_output").val(50);
                $(".temp-additional_drive_2").empty();
                $("#additional_drive_2").prop("disabled", true);
                $("#add_drive_2_output").prop("disabled", true);
                $('#additional_drive_2').parent().addClass('disabled');
                $('#additional_drive_2').parent().find('div').addClass('disabled');

                if (!$("#is_additional_drive_1").is(":checked") && !$("#is_additional_drive_3").is(":checked")) {
                    $("#additional_drive_div").addClass("d-none");
                }
            }
        });

        $("#is_additional_drive_3").on("click", function () {
            if ($("#is_additional_drive_3").is(":checked")) {
                $("#additional_drive_3").prop("disabled", false);
                $("#add_drive_3_output").prop("disabled", false);
                $('#additional_drive_3').parent().removeClass('disabled');
                $('#additional_drive_3').parent().find('div').removeClass('disabled');
            } else {
                $("#additional_drive_3").val(50);
                $("#add_drive_3_output").val(50);
                $(".temp-additional_drive_3").empty();
                $("#additional_drive_3").prop("disabled", true);
                $("#add_drive_3_output").prop("disabled", true);
                $('#additional_drive_3').parent().addClass('disabled');
                $('#additional_drive_3').parent().find('div').addClass('disabled');

                if (!$("#is_additional_drive_1").is(":checked") && !$("#is_additional_drive_2").is(":checked")) {
                    $("#additional_drive_div").addClass("d-none");
                }
            }
        });

        $("#name").keyup(function () {
            $(".vm_name_count").html($(this).val().length);
            $(".temp-name").empty();
            $(".temp-name").append(`<strong>VM#:</strong> ${$("#name").val()}<br>`);
            if (!$("#temp-vm").hasClass("p-2")) $("#temp-vm").addClass("p-2");
        });

        $("#memory_size").change(function () {
            $(".temp-memory_size").empty();
            $(".temp-memory_size").append(`<strong>Memory:</strong> ${$("#memory_size").val()}GB<br>`);
            if (!$("#temp-vm").hasClass("p-2")) $("#temp-vm").addClass("p-2");
        });

        $("#cpu").change(function () {
            $(".temp-cpu").empty();
            $(".temp-cpu").append(`<strong>CPUs:</strong> ${$("#cpu").val()}<br>`);
            if (!$("#temp-vm").hasClass("p-2")) $("#temp-vm").addClass("p-2");
        });

        $("#storage_size").change(function () {
            $(".temp-storage_size").empty();
            let valueInfo = Number($("#storage_size").val() * per_gb_rate).toFixed(2);
            $(".temp-storage_size").append(`<strong>Storage:</strong> ${$("#storage_size").val()}GB&nbsp;<small>($${valueInfo}/month)</small><br>`);
            if (!$("#temp-vm").hasClass("p-2")) $("#temp-vm").addClass("p-2");
        });

        $("#additional_drive_1").change(function () {
            $(".temp-additional_drive_1").empty();
            let valueInfo = Number($("#additional_drive_1").val() * per_gb_rate).toFixed(2);
            $(".temp-additional_drive_1").append(`<strong>Additional Storage 1:</strong> ${$("#additional_drive_1").val()}GB&nbsp;<small>($${valueInfo}/month)</small><br>`);
        });

        $("#additional_drive_2").change(function () {
            $(".temp-additional_drive_2").empty();
            let valueInfo = Number($("#additional_drive_2").val() * per_gb_rate).toFixed(2);
            $(".temp-additional_drive_2").append(`<strong>Additional Storage 2:</strong> ${$("#additional_drive_2").val()}GB&nbsp;<small>($${valueInfo}/month)</small><br>`);
        });

        $("#additional_drive_3").change(function () {
            $(".temp-additional_drive_3").empty();
            let valueInfo = Number($("#additional_drive_3").val() * per_gb_rate).toFixed(2);
            $(".temp-additional_drive_3").append(`<strong>Additional Storage 3:</strong> ${$("#additional_drive_3").val()}GB&nbsp;<small>($${valueInfo}/month)</small><br>`);
        });

        $("#group_id").change(function () {
            if ($("#group_id").val() == "custom") {
                Swal.fire({
                    title: "Add Custom Group",
                    input: 'text',
                    inputAttributes: {
                        input: 'text',
                        placeholder: 'Enter custom group name',
                    },
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Add Group",
                    customClass: {
                        validationMessage: "my-validation-message",
                        input: 'form-control',
                    },
                    preConfirm: (value) => {
                        let regExp = /^[a-zA-Z0-9_ -]*$/;
                        if (value.trim() == "") {
                            Swal.showValidationMessage('Group name is required');
                        }
                        if (!regExp.test(value)) {
                            Swal.showValidationMessage('Please enter valid string!');
                        }
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        $(".loading").removeClass("d-none");
                        $.ajax({
                            url: baseUrl + "/groups/store",
                            type: "POST",
                            dataType: "JSON",
                            data: { group_name: result.value },
                            success: function (response) {
                                $(".loading").addClass("d-none");

                                if (response.status == "success") {
                                    let html = '<option value="' + response.data.group_id + '" selected>' + response.data.group_name + "</option>";
                                    $("#group_id").append(html);
                                    $("#group_id").val(response.data.group_id);
                                    $(".temp-group").empty();
                                    $(".temp-group").append(`<strong>Group:</strong> ${$("#group_id option:selected").text()}<br>`);
                                    if (!$("#temp-vm").hasClass("p-2"))
                                        $("#temp-vm").addClass("p-2");
                                }
                            },
                        });
                    } else {
                        $(".temp-group").empty();
                        $("#group_id").val("");
                    }
                });
            } else {
                $(".temp-group").empty();
                $(".temp-group").append(`<strong>Group:</strong> ${$("#group_id option:selected").text()}<br>`);
                if (!$("#temp-vm").hasClass("p-2"))
                    $("#temp-vm").addClass("p-2");
            }
        });

        $("#os_version").change(function () {
            $(".temp-os-version").empty();
            $(".temp-os-version").append(`<strong>Version:</strong> ${$("#os_version").val()}<br>`);
        });

        $(".guest_os").on("click", function () {
            let os = $(this).val();
            $.ajax({
                url: baseUrl + "/admin/get-versions",
                type: "POST",
                dataType: "JSON",
                data: { os: os },
                success: function (response) {
                    if (response.status == "success") {
                        let html = '<option value="">Select OS</option>';
                        $.each(response.versions, function (i, v) {
                            html +='<option value="' + i + '">' + v + "</option>";
                        });
                        $("#os_version").html(html);
                    }
                },
            });
        });

        $("#single_cpu").click(function () {
            if ($("#single_cpu").is(":checked")) {
                $("#cpu").attr({ max: 1, min: 1, step: 1, value: 1 });
                $("#cpu_output").prop({ max: 1, min: 1, step: 1, value: 1 });
                $('#cpu').parent().addClass('disabled');
                $('#cpu').parent().find('div').addClass('disabled');
                slider.slider("cpu_div", {'disable': true, });
            } else {
                $("#cpu").attr({
                    max: cpu_setting_size,
                    min: 0,
                    step: 2,
                    value: 0,
                });
                $("#cpu_output").prop({
                    max: cpu_setting_size,
                    min: 0,
                    step: 2,
                    value: 0,
                });
                $('#cpu').parent().removeClass('disabled');
                $('#cpu').parent().find('div').removeClass('disabled');
                slider.slider("cpu_div", {'disable': false, });
            }
            $("#cpu_output").val($("#cpu").val());
            $("#cpu").trigger("change");
        });

        $("#salesInquiry").on("click", function () {
            Swal.fire({
                title: "Are you sure?",
                text: "By submitting, you're agreeing to be contacted by a cywestEdge Sales Representative to discuss your quote.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Do it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    $(".loading").removeClass("d-none");
                    $.ajax({
                        url: baseUrl + "/sales-inquiry",
                        type: "GET",
                        success: function (response) {
                            $(".loading").addClass("d-none");
                            if (response.status) {
                                edgeCommon.swalSuccess(response.message).then(() => {
                                    window.location.reload();
                                });
                            }
                        },
                    });
                }
            });
        });
        
    }

    let numberWithCommas = function(number) {
        //Separates the components of the number
        let n= number.toString().split(".");
        //Comma-fes the first part
        n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        //Combines the two sections
        return n.join(".");
    }

    let addToStrongBox = function (strongBox) {
        $.ajax({
            url: baseUrl + "/strongboxes",
            type: "POST",
            dataType: "JSON",
            data: strongBox,
            success: function (response) {
                if (response.status == "success") {
                    edgeCommon.swalSuccess("StrongBox Added Successfully").then((result) => {
                        if (result) {
                            if (strongBox.print) {
                                window.location.href = baseUrl + "/pdf/" + response.data.id;
                                setTimeout(function () {
                                    window.location.href = baseUrl + "/strongboxes";
                                }, 1000);
                            } else {
                                window.location.href = baseUrl + "/strongboxes";
                            }
                        }
                    });
                }
            },
        });
    };

    let optimizeStrongBox = function (strongBox) {
        $(".loading").removeClass("d-none");
        $.ajax({
            url: baseUrl + "/strongbox/optimized",
            type: "POST",
            dataType: "JSON",
            data: strongBox,
            success: function (response) {
                if (response.status == "success") {
                    Swal.fire({
                        title: "Success",
                        html: "StrongBox quote generated successfully. Click on <strong>Purchase Now</strong> or <strong>Sales Inquiry</strong> to complete your quote.",
                        type: "success",
                        icon: "success",
                    }).then((result) => {
                        if (result) {
                            window.location.href = baseUrl + "/strongboxes";
                        }
                    });
                } else {
                    edgeCommon.swalError(response.message);
                }
            },
            error: function(xhr) { // if error occurred
                let err = eval("(" + xhr.responseText + ")");
                edgeCommon.swalError(err.message);
                console.log(`Error occurred. please try again ${err.message}`);
            },
            complete: function() {
                $(".loading").addClass("d-none");
            },
        });
    };

    let optimizeSelectedStrongBox = function (strongBox) {
        $(".loading").removeClass("d-none");
        $.ajax({
            url: baseUrl + "/strongbox/optimized-selected",
            type: "POST",
            dataType: "JSON",
            data: strongBox,
            success: function (response) {
                setTimeout(function () {
                    if (response.status == "success") {
                        $(".loading").addClass("d-none");
                        Swal.fire({
                            title: response.title ?? "",
                            html: response.message,
                            type: "success",
                            confirmButtonColor: "#198754",
                            confirmButtonText: "CLOSE THIS MESSAGE",
                            width: 800,
                        }).then((result1) => {
                            if (result1) {
                                window.location.href = baseUrl + "/strongboxes";
                            }
                        });
                    }
                }, 3000);
            },
        });
    };

    let deleteStrongBox = function () {
        $(".delete-group").on("click", function () {
            let id = $(this).data("id");
            let groupName = $(this).data("grpname");
            let user_id = $(this).data("added");
            if (user_id == "") {
                edgeCommon.swalWarning("You can`t delete group, Group has assign virtual machine!");
            } else {
                if (id) {
                    Swal.fire({
                        title: "Are you sure you want to delete group " + groupName + "?",
                        text: "Deleting this Group will move all VMs to Default group contained with it.",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes, delete it!",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            $(".loading").removeClass("d-none");
                            $.ajax({
                                url: baseUrl + "/admin/groups/delete/" + id,
                                type: "DELETE",
                                dataType: "JSON",
                                success: function (response) {
                                    $(".loading").addClass("d-none");
                                    if (response.status == "success") {
                                        Swal.fire({
                                            title: "Deleted!",
                                            text: "Group has been deleted successfully",
                                            type: "success",
                                            icon: "success",
                                        }).then((result1) => {
                                            if (result1) {
                                                window.location.href = baseUrl + "/strongboxes";
                                            }
                                        });
                                    }
                                },
                            });
                        }
                    });
                }
            }
        });

        $(".delete-group-admin").on("click", function () {
            let id = $(this).data("id");
            let groupName = $(this).data("grpname");
            if (groupName == "default") {
                edgeCommon.swalWarning("You can`t delete Default group");
            } else if (id) {
                Swal.fire({
                    title: "Are you sure you want to delete group " + groupName + "?",
                    text: "Deleting this Group will move all VMs to Default group contained with it.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, delete it!",
                }).then((result1) => {
                    if (result1.isConfirmed) {
                        $(".loading").removeClass("d-none");
                        $.ajax({
                            url: baseUrl + "/admin/groups/delete/" + id,
                            type: "DELETE",
                            dataType: "JSON",
                            success: function (response) {
                                $(".loading").addClass("d-none");
                                if (response.status == "success") {
                                    Swal.fire({
                                        title: "Deleted!",
                                        text: "Group has been deleted successfully",
                                        type: "success",
                                        icon: "success",
                                    }).then((result) => {
                                        if (result) {
                                            window.location.href = baseUrl + "/strongboxes";
                                        }
                                    });
                                }
                            },
                        });
                    }
                });
            } else {
                edgeCommon.swalWarning("You can`t delete group, Group has assign virtual machine!");
            }
        });
    };

    let dragDrop = function() {
           
        $("#padding-item-drop, #complete-item-drop")
            .sortable({
                connectWith: ".connectedSortable",
                opacity: 0.5,
                placeholder: "ui-state-highlight",
                receive: function () {
                    updateStrongBoxes();
                },
                update: function () {
                    //triggered when sorting stopped
                    let cpuCount = 0;
                    let memoryCount = 0;
                    $("#complete-item-drop .vm-listing").each(function () {
                        memoryCount = memoryCount + parseInt($(this).attr("memory"));
                        cpuCount = cpuCount + parseInt($(this).attr("cpu"));
                    });

                    if (memoryCount > ram_setting_size || cpuCount > cpu_setting_size) {
                        $(this).sortable("cancel");
                        edgeCommon.swalWarning("Memory space is full!");
                    } else {
                        $(".connectedSortable .vm-listing").addClass("d-none");
                        $(".memory-box-empty").each(function () {
                            let memory = $(this).attr("data-memory");
                            if (memoryCount >= memory) {
                                $(this).removeClass("memory-box-empty");
                                $(this).addClass("memory-box-full");
                            }
                        });

                        $(".cpu-box-empty").each(function () {
                            let cpu = $(this).attr("data-cpu");

                            if (cpuCount >= cpu) {
                                $(this).removeClass("cpu-box-empty");
                                $(this).addClass("cpu-box-full");
                            }
                        });
                    }
                },
            })
            .disableSelection();

        function updateStrongBoxes() {
            let cpuCount = 0;
            let memoryCount = 0;
            $("#complete-item-drop .vm-listing").each(function () {
                memoryCount = memoryCount + parseInt($(this).attr("memory"));
                cpuCount = cpuCount + parseInt($(this).attr("cpu"));
            });

            $(".connectedSortable .vm-listing").addClass("d-none");
            $(".memory-box-empty").each(function () {
                let memory = $(this).attr("data-memory");
                if (memoryCount >= memory) {
                    $(this).removeClass("memory-box-empty");
                    $(this).addClass("memory-box-full");
                }
            });

            $(".cpu-box-empty").each(function () {
                let cpu = $(this).attr("data-cpu");
                if (cpuCount >= cpu) {
                    $(this).removeClass("cpu-box-empty");
                    $(this).addClass("cpu-box-full");
                }
            });
        }

        $(".edit-strongbox").click(function () {
            let id = $(this).data("id");
            let $class = $(".padding-item-drop-" + id);

            $class.children(".vm-listing").each(function () {
                let $this = $(this);
                $this.appendTo("#complete-item-drop");
                $("#complete-item-drop").sortable("option", "receive")(null, {
                    item: $this,
                });
            });

            $(".edit-strongbox").prop("disabled", true);

            let sb_name = $(this)
                .parents(".accordion-item")
                .find(".sb-name")
                .data("name");
            if (sb_name) {
                $(".empty-sb-name").attr("data-name", sb_name);
                $(".empty-sb-name").text(sb_name);
            }
        });

        $(".save-empty-sb").click(function () {
            let pendingArr = [];
            let completeArr = [];
            let cpuCount = 0;
            let memoryCount = 0;
            let sb_name = $(".empty-sb-name").attr("data-name");
            $("#padding-item-drop .vm-listing").each(function () {
                pendingArr.push({
                    sb: $(this).attr("sb-id"),
                    vm: $(this).attr("vm-id"),
                });
            });

            $("#complete-item-drop .vm-listing").each(function () {
                memoryCount += memoryCount + $(this).attr("memory");
                cpuCount += cpuCount + $(this).attr("memory");
                completeArr.push({
                    sb: $(this).attr("sb-id"),
                    vm: $(this).attr("vm-id"),
                });
            });

            if (completeArr) {
                if (completeArr.length == 0) {
                    edgeCommon.swalWarning("Sorry, the StrongBox is empty");
                } else {
                    Swal.fire({
                        title: "Are you sure?",
                        text: "You want to create a new StrongBox",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes, Do it!",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            $(".loading").removeClass("d-none");
                            $.ajax({
                                url: baseUrl + "/strongbox/empty-strongbox",
                                type: "POST",
                                dataType: "JSON",
                                data: {
                                    completeArr: completeArr,
                                    strongbox_name: sb_name,
                                },
                                success: function (response) {
                                    $(".loading").addClass("d-none");
                                    if (response.status) {
                                        Swal.fire({
                                            text: response.message,
                                            type: response.status,
                                            icon: response.status,
                                        }).then((result1) => {
                                            if (result1) {
                                                window.location.href = baseUrl + "/strongbox/empty-strongbox";
                                            }
                                        });
                                    }
                                },
                            });
                        }
                    });
                }
            }
        });


    }

    let initListing = function () {
        addValidations();
        updateStrongBox();
        deleteStrongBox();
        updateProfile();
        updateBilling();
        dragDrop();
    };

    return {
        // public functions
        init: function () {
            initListing();
        },
    };
}();

$(document).ready(function () {
    //input mask for phone
    $(".phone_mask ").mask("(000) 000-0000"); //specifying options
    $(".country_code_mask ").mask("000");
    $(".bi-question-circle-fill").tooltip();

    // create a new tag input:
    // tagsInput(document.querySelector('input[type="tags"]'));
    $(".input-tags").tagsInput({
        height: "50px",
        width: "100%",
        interactive: true,
        defaultText: "Add Tag",
    });


    $("#start_date, #end_date").daterangepicker(
        {
            locale: {
                format: "YYYY-MM-DD H:mm:ss",
            },
            alwaysShowCalendars: true,
            // "minDate": moment().format("YYYY-MM-DD H:mm:ss"),
            // "maxDate": moment().add('months', 1),
            autoApply: true,
            autoUpdateInput: false,
            timePicker: true,
            timePicker24Hour: true,
        },
        function (start, end) {
            // Lets update the fields manually this event fires on selection of range
            let selectedStartDate = start.format("YYYY-MM-DD H:mm:ss"); // selected start
            let selectedEndDate = end.format("YYYY-MM-DD H:mm:ss"); // selected end

            $startDateInput = $("#start_date");
            $endDateInput = $("#end_date");

            // Updating Fields with selected dates
            $startDateInput.val(selectedStartDate);
            $endDateInput.val(selectedEndDate);

            // Setting the Selection of dates on calender on CHECKOUT FIELD (To get this it must be bind by Ids not Class)
            let endDatePicker = $endDateInput.data("daterangepicker");
            endDatePicker.setStartDate(selectedStartDate);
            endDatePicker.setEndDate(selectedEndDate);

            // Setting the Selection of dates on calender on CHECK-IN FIELD (To get this it must be bind by Ids not Class)
            let startDatePicker = $startDateInput.data("daterangepicker");
            startDatePicker.setStartDate(selectedStartDate);
            startDatePicker.setEndDate(selectedEndDate);
        }
    );

    $("#select_month").daterangepicker({
        maxDate: new Date(),
        singleDatePicker: true,
        locale: {
            format: "YYYY/MM",
        },
    });

    $("#orderMonth").daterangepicker({
        singleDatePicker: true,
        showDropdowns: true,
        autoApply:true,
        locale: {
            format: "YYYY-MM-DD",
        },
    });

    $("#startDate, #endDate").daterangepicker({
        singleDatePicker: true,
        showDropdowns: true,
        autoApply:true,
        locale: {
            format: "YYYY-MM-DD",
        },
    });

    $('#startDate').on('change', function(){
        let aMinDate = new Date(Date.parse($(this).val()));
        $('#endDate').daterangepicker({
            minDate: aMinDate,
            singleDatePicker: true,
            showDropdowns: true,
            autoApply:true,
            locale: {
                format: "YYYY-MM-DD",
            },
        })
    });

    custom.init();
});
